export enum IdentityDocumentRequiredEnum {
  NEVER = "NEVER",
  ALWAYS = "ALWAYS",
  IF_NO_LICENSE = "IF_NO_LICENSE",
}
